<template>
	<div class="classList">
		<!-- 导航栏 -->
		<back-to></back-to>
		<List ref="changList" :themeId='themeId' :ticketShow='true'></List>
	</div>
</template>

<script>
	import List from '@/components/List.vue'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'classList',
		components: {
			List,
			BackTo
		},
		data() {
			return {
				themeId: ""
			}
		},
		created() {
			this.themeId = this.$route.query.id
		},
		mounted() {
			this.$nextTick(() => {
				this.$refs.changList.page = 1
				this.$refs.changList.connect_ProductList()
			});
		},
		methods: {

		}
	}
</script>

<style>
	.classList {
		background-color: #f3f5f4;
	}
</style>
